const langTr = {
    selectACountry: "Ülke Seçiniz",
    turkish: "Türkçe",
    english: "English",
    japanese: "JAPAN",
    settings: "Ayarlar",
    close: "Kapat",
    language: "Dil",
    giveUp: "Pes Et",
    guess: "Tahmin Et",
    share: "Paylaş",
    answer: "Cevap",
    win: "Kazandın",
    lose: "Kaybettin",
    maps: "Harita",
    wiki: "Viki",
    congratulations: "Tebrikler, bugünün cevabını buldunuz:",
    unfortunately: "Maalesef, bugünün cevabını bulamadınız:",
    copy: "Cevabınız kopyalandı",
    nextNationleIn: "Sıradaki Nationle'a ",
    hours: " saat ",
    minutes: " dakika ",
    seconds: " saniye",
    stats: "İstatistik",
    nextNationleIsReady: "Sıradaki Nationle hazır. Yeni ülke için sayfayı yenileyin.",
    viewCountry: "Ülkeyi Google Haritalar'da görüntüleyin",
    areYouGivingUp: "Pes etmek istiyor musunuz?",
    yes: "Evet",
    no: "Hayır",
    howToPlay: "Nasıl Oynanır?",
    guessTheCountry: "Günün ülkesini 6 tahminde bulmaya çalışın. Her tahminden sonra, tahmininizle hedef ülke arasındaki mesafe ve yön verileri aktarılır.",
    example: "Örnek",
    theTarget: "Hedef ülke, Azerbaycan'dan 1162 km uzakta ve batıda.",
    nextGuess: "Sıradaki tahmin, Türkiye. Tebrikler!",
    inspiredBy: "İlham",
    madeBy: "Yaratıcı",
    heavilyInspired: "Nationle'ın ilham kaynağı: ",
    creator: "Nationle'ın yaratıcısı: ",
    youCanReach: ". Kaynak koduna buradan ",
    support: " Destek olmak isterseniz, bana bir kahve ",
    sourceCode: "ulaşabilirsiniz.",
    coffee: "ısmarlayabilirsiniz.",
    createdBy: "'ın yaratıcısı ",
    and: " ve ",
    showMap: "Haritayı Göster",
    mapDisabled: "Harita ve bayrak gizlendi. Tekrar görmek için ayarlara gir.",
    flagMode: "Bayrak Modu",
    azerbaijan: "Azerbaycan",
    turkey: "Türkiye",
    wikiMessage: "Ülkeyi Vikipedi'de görüntüleyin",
    avgDistance: "Ortalama Mesafe",
    winRate: "Kazanma Oranı",
    winStreak: "Peşpeşe Kazanma",
    back: "Geri",
    next: "İleri",
    guessChart: "Tahmin",
    loseChart: "Kaybetme",
    europe: "Avrupa",
    asia: "Asya",
    africa: "Afrika",
    southAmerica: "Güney Amerika",
    northAmerica: "Kuzey Amerika",
    oceania: "Okyanusya"
  }
  
  export default langTr;